import React from 'react';
import { CustomerDashboard } from '../components/dashboard/CustomerDashboard';

const DashboardPage = () => {
  return <CustomerDashboard />;
};

export default DashboardPage;
